<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Help",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Help",
            items: [
              
               {
                  text: "Help",
                  active: true,
               },        
            ],            

            token: '',
            errors: {},
            enquiry: '',
           
         };
      },
      mounted() {        

      },

      methods: {
      

         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },    

         addEnquiry() {
            this.getToken();
            
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            var data = JSON.stringify({
               "enquiry": this.enquiry,               
            });

            this.loading = true;            
            this.errors = {};
            this.$axios
               .post("/api/hub/submitEnquiry", data, config)
               .then((response) => {
                  //console.log(response);
                  if (response.data.status) {
                     
                     this.$swal("", response.data.message, "success");
                     this.$router.push({ name: "dashboard" });
                     
                     
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <form class="form-horizontal" role="form" @submit.prevent="addEnquiry">
                     
                        <h4 class="card-title mt-3">Submit your enquiry here. We will do the best to help you.</h4>
                     
                        <div class="row mt-4"> 

                           <b-form-group class="col-lg-12">
                              <label>Enquiry <span class="text-danger">*</span></label>
                              <b-form-textarea v-model="enquiry" v-bind:class="{ 'is-invalid': Boolean(errors.enquiry) }" rows="10"></b-form-textarea>

                              <div v-for="(val, index) in errors.enquiry" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>                          
                           
                        </div>

                     
                     <div class="row mt-3">
                        <div class="12">
                           <button class="btn btn-primary me-2" type="submit">Submit</button>
                           <router-link :to="{ name: 'dashboard' }" class="btn btn-light">Cancel</router-link>
                        </div>
                     </div>
                  </form>
               </div>

            </div>
         </div>
      </div>
   </Layout>
</template>
